<form class="two-way-spot" [formGroup]="form">
  <div
    class="two-way-spot__buttons"
    *ngIf="contentEditable && indicesToHighlight?.length"
  >
    <button (click)="increaseSpot(false, true)">
      <img src="assets/rewind.svg" />
    </button>

    <button
      (click)="increaseSpot(false, false)"
      class="two-way-spot__buttons__1-pip"
    >
      <img src="assets/square-minus.svg" />
    </button>
  </div>
  @if (twoWayMode) {
    <div class="two-way-spot__side-container">
      <app-number-highlighter
        class="two-way-spot__side-container__number-highlighter"
        [value]="form.controls[bidName].value"
        [startAfterDecimal]="true"
        [indicesToHighlight]="indicesToHighlight"
        [contentEditable]="contentEditable"
        [pending]="pending"
        (onValueChange)="onNumberChange('bid', $event)"
        (onFocus)="onFocus('bid')"
        (onBlur)="onFieldBlur()"
      ></app-number-highlighter>
      <input-with-spinner
        *ngIf="contentEditable"
        [inert]="true"
        #inputAsk
        [formControlName]="bidName"
        class="two-way-spot__side-container__input-with-spinner"
        [tabindex]="-1"
      ></input-with-spinner>
    </div>
    <div class="two-way-spot__divider">/</div>
    <div class="two-way-spot__side-container">
      <app-number-highlighter
        class="two-way-spot__side-container__number-highlighter"
        [value]="form.controls[askName].value"
        [startAfterDecimal]="true"
        [indicesToHighlight]="indicesToHighlight"
        [contentEditable]="contentEditable"
        [pending]="pending"
        (onValueChange)="onNumberChange('ask', $event)"
        (onFocus)="onFocus('ask')"
        (onBlur)="onFieldBlur()"
      ></app-number-highlighter>
      <input-with-spinner
        *ngIf="contentEditable"
        [inert]="true"
        #inputAsk
        [formControlName]="askName"
        class="two-way-spot__side-container__input-with-spinner"
        [tabindex]="-1"
      ></input-with-spinner>
    </div>
  } @else {
    <div class="two-way-spot__side-container">
      <app-number-highlighter
        class="two-way-spot__side-container__number-highlighter"
        [value]="form.controls[midName].value"
        [startAfterDecimal]="true"
        [indicesToHighlight]="indicesToHighlight"
        [contentEditable]="contentEditable"
        [pending]="pending"
        (onValueChange)="onNumberChange('singleWay', $event)"
        (onFocus)="onFocus('singleWay')"
        (onBlur)="onFieldBlur()"
      ></app-number-highlighter>
      <input-with-spinner
        *ngIf="contentEditable"
        [inert]="true"
        #inputAsk
        [formControlName]="midName"
        class="two-way-spot__side-container__input-with-spinner"
        [tabindex]="-1"
      ></input-with-spinner>
    </div>
  }

  <div
    class="two-way-spot__buttons"
    *ngIf="contentEditable && indicesToHighlight?.length"
  >
    <button
      (click)="increaseSpot(true, false)"
      class="two-way-spot__buttons__1-pip"
    >
      <img src="assets/square-plus.svg" />
    </button>
    <button (click)="increaseSpot(true, true)">
      <img src="assets/fast-forward.svg" />
    </button>
  </div>
</form>
